

















import {
  Component,
  Prop,
  Vue,
  Watch,
  InjectReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const productCreate = namespace("productCreate");
@Component({})
export default class channelAttrBrand extends Vue {
  @InjectReactive("curChannel") curChannel;
  @InjectReactive("curCategory") curCategory;
  @productCreate.Action queryConnBrandList;
  // 0：单选；1：多选；2：输入框；3：数字；4：富文本；5：日期；6：对象；7：单选可输入；8：多选可输入，9：其他
  @Prop({ default: () => {} }) node; // 属性结构数据对象
  @Prop({ default: () => "" }) dataValue; // 需要回显的值
  @Prop({ default: null }) brandApiParam; // 需要回显的值
  @Prop({ default: false }) disabled;
  curValue = "";
  brandList = [];
  @Watch("dataValue", { immediate: true })
  watchDataValue(val) {
    this.curValue = val;
    this.$nextTick(function() {
      let ref = this.$refs.selectBrandSelect as any;
      this.$emit("changeSelect", { ref, isSelectChange: false });
    });
  }
  @Watch("curValue")
  watchCurValue(val) {
    this.$emit("update:dataValue", val);
  }
  get disabledBrand() {
    return this.disabled;
  }
  async created() {
    let finalParamObj = this.brandApiParam || this.curChannel;
    // 获取渠道品牌列表
    let res = await this.queryConnBrandList({
      input: {
        channelCode: finalParamObj.channelCode,
        shopCode: finalParamObj.value
      }
    });
    this.brandList = res;
  }
  changeSelect() {
    this.$nextTick(function() {
      let ref = this.$refs.selectBrandSelect as any;
      this.$emit("changeSelect", { ref, isSelectChange: true });
    });
  }
}
